var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.news = {
	init : function() {
		site.news.onHover();
	},
	onHover : function() {
		$('.frontLeft .frontNews .small .item').hover(function() {
			$parent = $(this);

			$('.frontLeft .frontNews .big .item').each(function() {
				$(this).removeClass('active');
				if ($(this).data("item") == $parent.data("item")) {
					$(this).addClass('active');
				}
			});
		});
	}
};
site.inits.push('site.news.init()');

site.extras = {
	frontpage : {
		init: function() {
			$('.frontBottom .category .tabs').tabs();
			site.owl.init(".frontBottom .category .tabs .images", {
				items: 1,
				loop: false ,
				autoplay: true,
				autoplayTimeout: 8000,
				autoplaySpeed: 2000,
				autoplayHoverPause: true
			});
		}
	}
};
site.inits.push('site.extras.frontpage.init()');

site.tube = {
	init : function() {
		$tube = $('body.frontpage .frontLeft .frontTube').clone();
		$('body.frontpage .frontBottom').prepend($tube.clone());
		$tube.insertAfter('body.frontpage .frontRight .frontCalendar');
	}
};
site.inits.push('site.tube.init()');

site.calendar = {
	init : function() {
		setTimeout(function() {
			site.calendar.calcMargin();
		}, 500);

		$(window).resize(function() {
			site.calendar.calcMargin();
		})

	},
	calcMargin : function() {
		$margin = 30 + $('.frontLeft .frontNews .small').outerHeight() + $('.frontLeft .frontNews .entriesFooter').outerHeight() + 40;
		$('body.frontpage.is .frontRight .frontCalendar .boxText').css('margin-bottom', $margin);
	}
};
site.inits.push('site.calendar.init()');

site.spons = {
	init: function() {
		site.owl.init('body.frontpage .frontSponsors ul', {
			items: 6,
			loop: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplaySpeed: 2000,
			autoplayHoverPause: true,
			responsive: {
				768: {
					items: 6
				},
				1: {
					items: 3
				}
			}
		});
		var $loc = $('#header #topSpons');
		var $img = $loc.find('ul li a img.responsive');
		if ($img.length > 0) {
			$loc.css('background-image', 'url(' + $img.data('src') + ')');
			$loc.find('a').attr('title', $img.attr('alt'));
		}
	}
};
site.inits.push('site.spons.init()');

site.webcam = {
	init: function() {
		var $boxText  =$('.frontWebcam .boxText').append('<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><span class="sr-only">Loading...</span>')
		$('.frontWebcam img').load(function() {
			console.log('Webcam Loaded');
			$boxText.addClass("loaded")
		})
	}
};
site.inits.push('site.webcam.init()');

site.sitemap = {
	init: function() {
		$('.box_sitemap .mmLevel1 li.children').each(function() {
			var $children = $(this).find('ul.mmLevel2');
			var $li = $(this)
			$li.addClass("noAnimation");
			var $size = 0;
			$children.find('> li').each(function() {
				$size += $(this).height();
			});
			$children.css('height', $size);
			setTimeout(function() {
				$li.removeClass("noAnimation");
			}, 500);

		});

		$('.box_sitemap .mmLevel1  > li.children.goto > a').click(function(e) {
			e.preventDefault();
			var $parent = $(this).parent();
			$parent.toggleClass('open');
		});

		$('.box_sitemap .mmLevel1 li.selectedLevel1').addClass('open');
	}
}
site.inits.push('site.sitemap.init()');

site.bg = {
	init: function() {
		site.bg.onResize();
		$(window).resize(function() {
			site.bg.onResize();
		})
	},
	onResize : function() {
		$('#contentContainer .whiteBg').css('min-height', 0);
		var $newSize = $('#page').outerHeight() - $('#header').outerHeight();
		$('#contentContainer .whiteBg').css('min-height', $newSize);
	}
};
//site.inits.push('site.bg.init()');

site.headers = {
	init: function() {
		$('.skew').hover(function() {
			$(this).parent().siblings().toggleClass('hover');
		})
	}
};
site.inits.push('site.headers.init()');

site.footer = {
	init: function() {
		$('#footerInfo .boxText h4').wrap("<div class='boxTitle'></div>")
	}
}
site.inits.push('site.footer.init()');
// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
